/**
 * @module Widget
 */

import { Component, Input } from '@angular/core';
import { WidgetLayersClass } from '@class/widgetLayers.class';
import { ItemColor } from '@functions/item.functions';

@Component({
  selector: 'app-widget-indicators-label',
  templateUrl: './widget-indicators-label.component.html',
  styleUrls: ['./widget-indicators-label.component.css']
})
export class WidgetIndicatorsLabelComponent {

  @Input() widgetLayers: WidgetLayersClass;
  @Input() current: number;

  color = ItemColor('indicators');

  constructor() {}

}
